import Deployments from './Deployments';
import Settings from './Settings';
import { Container } from './styled';

function Details() {
  return (
    <Container sx={{ display: { xs: 'none', lg: 'flex' } }}>
      <Settings />
      <Deployments />
    </Container>
  );
}

export default Details;
